export default __webpack_public_path__ + "static/media/cat-rMIN.jpg.11157f61.txt";